import {
  EmployeeEstimatedPeriodBaseSalaryDocument,
  EmployeeEstimatedPeriodBaseSalaryQuery,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type EmployeeEstimatedPeriodBaseSalary =
  EmployeeEstimatedPeriodBaseSalaryQuery['payroll']['employeeEstimatedPeriodBaseSalaries'][number]

export const useEmployeeEstimatedPeriodBaseSalary = (policyPeriodId: number) => {
  const { data, loading, error } = useQuery(EmployeeEstimatedPeriodBaseSalaryDocument, {
    variables: {
      policyPeriodId,
    },
  })

  const estimatedPeriodBaseSalaryData: EmployeeEstimatedPeriodBaseSalary[] =
    data?.payroll.employeeEstimatedPeriodBaseSalaries ?? []

  return {
    loading,
    data: estimatedPeriodBaseSalaryData,
    error,
  }
}
